(function($) {
    
  var allPanels = $('.accordion > dd').hide(500);
    
  $('.accordion > dt > a').click(function() {
    allPanels.slideUp(500);
    $(this).parent().next().slideDown(500);
    return false;
  });

})(jQuery);

  $( function() {
    $( "#accordion" ).accordion();
  } );


$(".acordeon").on("click", ".acordeon-cabecera", function() {
  $(this).toggleClass("active").next().slideToggle();
});
